import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';
import { Facebook, Instagram, Twitter } from '@mui/icons-material';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          {/* Logo ve Hakkında */}
          <Grid item xs={12} sm={4}>
            <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
              <img
                src="/images/logo.jpg"
                alt="Kayla Butik Logo"
                style={{
                  height: '80px',
                  marginBottom: '1rem',
                  objectFit: 'contain'
                }}
              />
              <Typography variant="body2" color="text.secondary" paragraph>
                Moda ve stilin buluşma noktası. Kayla Butik ile tarzınızı yansıtın.
              </Typography>
            </Box>
          </Grid>

          {/* Hızlı Linkler */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom align="center">
              Hızlı Linkler
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', sm: 'flex-start' } }}>
              <Link href="/" color="inherit" sx={{ mb: 1, textDecoration: 'none' }}>
                Ana Sayfa
              </Link>
              <Link href="/products" color="inherit" sx={{ mb: 1, textDecoration: 'none' }}>
                Ürünler
              </Link>
              <Link href="/categories" color="inherit" sx={{ mb: 1, textDecoration: 'none' }}>
                Kategoriler
              </Link>
              <Link href="/contact" color="inherit" sx={{ mb: 1, textDecoration: 'none' }}>
                Bize Ulaşın
              </Link>
            </Box>
          </Grid>

          {/* İletişim */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom align="center">
              İletişim
            </Typography>
            <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
              <Typography variant="body2" color="text.secondary">
                Adres: İstanbul, Türkiye
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Email: info@kaylabutik.com
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Tel: +90 (531) 694 97 44
              </Typography>
              {/* Sosyal Medya İkonları */}
              <Box sx={{ mt: 2, display: 'flex', justifyContent: { xs: 'center', sm: 'flex-start' }, gap: 2 }}>
                <Link 
                  href="https://www.instagram.com/kaylabutikk?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                  target="_blank" 
                  color="inherit"
                  sx={{ 
                    '&:hover': { 
                      color: 'primary.main'   
                    } 
                  }}
                >
                  <Instagram />
                </Link>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* Alt Bilgi */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} KAYLA BUTİK. Tüm hakları saklıdır.
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Link href="/gizlilik-politikasi" color="inherit" sx={{ mx: 1, textDecoration: 'none', fontSize: '0.875rem' }}>
              Gizlilik Politikası
            </Link>
            |
            <Link href="/mesafeli-satis-sozlesmesi" color="inherit" sx={{ mx: 1, textDecoration: 'none', fontSize: '0.875rem' }}>
              Mesafeli Satış Sözleşmesi
            </Link>
            |
            <Link href="/iade-kosullari" color="inherit" sx={{ mx: 1, textDecoration: 'none', fontSize: '0.875rem' }}>
              İade Koşulları
            </Link>
            |
            <Link href="/kvkk-aydinlatma" color="inherit" sx={{ mx: 1, textDecoration: 'none', fontSize: '0.875rem' }}>
              KVKK Aydınlatma Metni
            </Link>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            İletişim: +90 (531) 694 97 44 | info@kaylabutik.com
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer; 